import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { includes } from "lodash";
import { CircularProgress, FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import loadProperty from "../property/ducks/actions";
import operations from "./ducks/operations";
import propertyOperations from "../property/ducks/operations";
import ResearchSnapshot from "./ResearchSnapshot";
import TrackResearchModal from "./TrackResearchModal";

const ResearchTab = (props) => {
    const [data, setData] = useState(null);
    const [newProperty, setNewProperty] = useState("");
    const [awaitingTrack, setAwaitingTrack] = useState(false);
    const [trackModalOpen, setTrackModalOpen] = useState(false);

    const { role, propertyKey, loadProperty, property } = props;

    const loadData = async () => {
        const data = await operations.getResearchByProperty(propertyKey);
        setData(data);
    };

    useEffect(() => {
        loadData();
        setNewProperty(property);
    }, []);

    const changeTracked = async () => {
        setNewProperty((prev) => ({
            ...property,
            trackedFlg: !prev.trackedFlg,
        }));
        setAwaitingTrack(true);
        const response = await propertyOperations.handleSubmitPropertyForm(true, newProperty, null);
        loadProperty(response.data);
        setAwaitingTrack(false);
    };

    const handleOpenTrackModal = () => {
        setTrackModalOpen(true);
    };

    const handleCloseTrackModal = () => {
        setTrackModalOpen(false);
    };

    return (
        <div>
            {data != null ? (
                <div>
                    {data === "error" ? (
                        <AlternateContentRed>A connection error occurred. Please refresh the page.</AlternateContentRed>
                    ) : (
                        <div>
                            <div style={{ display: "inline-block", width: "100%" }}>
                                <div style={{ float: "left" }}>
                                    <PaperHeading>Research</PaperHeading>
                                    <p className="page-subtitle" style={{ marginBottom: "16px" }}>{`SHOWING ${
                                        data.length
                                    } ${data.length === 1 ? "ENTRY" : "ENTRIES"} `}</p>
                                </div>
                                {includes(["research", "researchAdmin", "dataAdmin", "dataEntry"], role) ? (
                                    <div style={{ float: "right", marginTop: "12px" }}>
                                        {awaitingTrack === false ? (
                                            <div>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={newProperty.trackedFlg === true ? true : false}
                                                            onChange={() => handleOpenTrackModal()}
                                                            color="primary"
                                                            disabled={includes(["dataEntry"], role)}
                                                        />
                                                    }
                                                    label="Tracked"
                                                />
                                                <TrackResearchModal
                                                    modalOpen={trackModalOpen}
                                                    closeModal={handleCloseTrackModal}
                                                    confirm={changeTracked}
                                                    trackedValue={newProperty.trackedFlg}
                                                />
                                            </div>
                                        ) : (
                                            <LoadWheel>
                                                <CircularProgress size={20} />
                                            </LoadWheel>
                                        )}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            {data.length > 0 ? (
                                <div>
                                    {
                                        <RsContainer>
                                            <ResearchSnapshot {...props} snapshot={data} />
                                        </RsContainer>
                                    }
                                </div>
                            ) : (
                                <AlternateContent>No Research Snapshots exist for this property.</AlternateContent>
                            )}
                        </div>
                    )}
                </div>
            ) : (
                <AlternateContent>
                    <CircularProgress />
                </AlternateContent>
            )}
        </div>
    );
};

const styles = (theme) => ({
    container: {
        margin: "0 auto",
        position: "relative",
        alignItems: "center",
        paddingBottom: "20px",
    },
    rsContainer: {
        marginBottom: "20px",
    },
    alternateContent: {
        margin: "auto",
        textAlign: "center",
        marginTop: "3em",
        marginBottom: "3em",
        color: "rgba(0, 0, 0, 0.30)",
        fontSize: "20px",
    },
    alternateContentRed: {
        margin: "auto",
        textAlign: "center",
        marginTop: "3em",
        marginBottom: "3em",
        color: theme.palette.error.dark,
        fontSize: "20px",
    },
    defTerm: {
        fontSize: "13px",
        textTransform: "uppercase",
        color: "#9E9E9E",
        fontWeight: 600,
        lineHeight: "26px",
        whiteSpace: "nowrap",
    },
    paperHeading: {
        fontSize: "18px",
        margin: "14px 0",
    },
    customButtons: {
        display: "inline-block",
        float: "right",
        marginTop: "27px",
    },
    customButtonsBelow: {
        display: "inline-block",
        float: "right",
        marginTop: "0px",
    },
    customButton: {
        backgroundColor: "rgba(0, 0, 255, 0.0)",
        borderWidth: "1px",
        borderRadius: "4px",
        marginRight: "10px",
        height: "30px",
        width: "30px",
    },
    pageNumber: {
        padding: 0,
        marginRight: "10px",
        fontSize: "14px",
        display: "inline-block",
    },
    resultsLabel: {
        marginRight: "5px",
        fontSize: "16px",
    },
    resultsSelector: {
        marginRight: "10px",
        height: "30px",
        width: "40px",
        fontSize: "14px",
    },
    loadWheel: {
        textAlign: "center",
        width: "5em",
        display: "inline-block",
        marginTop: "15px",
    },
});

const Container = styled("div")(() => ({
    margin: "0 auto",
    position: "relative",
    alignItems: "center",
    paddingBottom: "20px",
}));

const RsContainer = styled("div")({
    marginBottom: "20px",
});

const AlternateContent = styled("div")({
    margin: "auto",
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
});

const AlternateContentRed = styled("div")(({ theme }) => ({
    margin: "auto",
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
    color: theme.palette.error.dark,
    fontSize: "20px",
}));

const PaperHeading = styled("h3")({
    fontSize: "18px",
    margin: "14px 0 2px 0",
});

const LoadWheel = styled("div")({
    textAlign: "center",
    width: "5em",
    display: "inline-block",
    marginTop: "15px",
});
export default connect(null, loadProperty)(ResearchTab);
